import { render } from "./NcrmContractItemFieldsCard.vue?vue&type=template&id=4a7b2450&scoped=true"
import script from "./NcrmContractItemFieldsCard.vue?vue&type=script&lang=js"
export * from "./NcrmContractItemFieldsCard.vue?vue&type=script&lang=js"

import "./NcrmContractItemFieldsCard.vue?vue&type=style&index=0&id=4a7b2450&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a7b2450"]])

export default __exports__